import { Chunk, FindChunks } from "react-highlight-words";

export const escapeRegex = (str: string) => {
  return str.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`).replaceAll(/\s+/g, String.raw`\s+`);
};

export const textToRegex = (text: string) => {
  const escapedWord = escapeRegex(text);
  return new RegExp(escapedWord, "gi");
};

const collectRegExpMatches = (word: RegExp, text: string): Chunk[] => {
  const regex = new RegExp(word.source, word.flags.includes("g") ? word.flags : word.flags + "g");
  const chunks: Chunk[] = [];
  let match;
  while ((match = regex.exec(text)) !== null) {
    chunks.push({ start: match.index, end: match.index + match[0].length });
  }
  return chunks;
};

const collectStringHighlightChunks = (word: string, text: string): Chunk[] => {
  try {
    const paragraphRegex = new RegExp(String.raw`(^|\n)${escapeRegex(word)}(?=\n|$)`, "gi");
    const chunks: Chunk[] = [];
    let match;
    while ((match = paragraphRegex.exec(text)) !== null) {
      chunks.push({ start: match.index, end: match.index + match[0].length });
    }
    if (chunks.length === 0) {
      const sentenceRegex = textToRegex(word.trim());
      while ((match = sentenceRegex.exec(text)) !== null) {
        chunks.push({ start: match.index, end: match.index + match[0].length });
      }
    }
    return chunks;
  } catch {
    const index = text.indexOf(word.trim());
    if (index > -1) {
      return [{ start: index, end: index + word.length }];
    }
    return [];
  }
};

export const findChunks = ({ textToHighlight, searchWords }: FindChunks): Chunk[] => {
  const chunks: Chunk[] = [];

  searchWords.forEach((word) => {
    if (word instanceof RegExp) {
      chunks.push(...collectRegExpMatches(word, textToHighlight));
    } else {
      const stringWord = word.toString().trim();
      if (!stringWord) return;
      const regex = textToRegex(stringWord);
      let match;
      while ((match = regex.exec(textToHighlight)) !== null) {
        chunks.push({ start: match.index, end: match.index + match[0].length });
      }
    }
  });

  return chunks;
};

export const findHighlightChunks = ({ textToHighlight, searchWords }: FindChunks): Chunk[] => {
  const chunks: Chunk[] = [];

  searchWords.forEach((word) => {
    if (word instanceof RegExp) {
      chunks.push(...collectRegExpMatches(word, textToHighlight));
    } else {
      chunks.push(...collectStringHighlightChunks(word.toString(), textToHighlight));
    }
  });

  return chunks;
};
